$( document ).ready(function() {
  
  if($(".template-product").length > 0){
    
    $(".box--Custom__properties").on("change", "select", function(e){
      var value = $(this).val();
      $(this).parents(".Custom__properties-select").find(".Custom__properties-label_value").text(value)
    });
    
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= $(".product-single__add-to-cart .btn--add-to-cart").offset().top) {
            $(".btn--add-to-cart-custom").addClass("is-active");
        } else{
            $(".btn--add-to-cart-custom").removeClass("is-active"); 
        }
    });
  
    $(".template-product").on("click", ".btn--add-to-cart-custom", function(e){
      e.preventDefault();
      $( ".Custom__properties-select .select__select" ).each(function() {    
        $( ".btn--add-to-cart" ).trigger( "click" );
        if( $( this ).val() == null){
          $('html,body').animate({
              scrollTop: $(".product__info-wrapper").offset().top
          },'slow');
        }
        
      });
    });
  
    $(".dbtfy-upsell_bundles ").on("change", ".Custom__properties_upsell .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      $this.removeClass("invalid");
      $this.parents(".Custom__properties-select").find(".error").removeClass("is-error");
      var value = $this.val();
      
      var html = `<option value="" selected="" disabled="">${Translations.choose_one}</option>`;
      if($(this).data("id") == "brand"){
        $this.parents(".Custom__properties_upsell").find(".Custom__properties-label_value").text(value);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name', `properties[${value} Model]`);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name-properties', `${value} Model`);
        Models.forEach(function(model){
          if(value == model.Brand){
            model.Models.split(/[,]+/).map(function(item){
              return html += `
                <option value="${item}">${item}</option>
              `
            })   
            $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").html(html)
          }
        })
        
      }
    });

    $(".box--Custom__properties ").on("change", ".Custom__properties-select .select__select", function(e){
      var $this = $(this);
      $this.removeClass("invalid");
      $this.parents(".Custom__properties-select").find(".error").removeClass("is-error");
      var value = $this.val();
      
      var html = `<option value="" selected="" disabled="">${Translations.choose_one}</option>`;
      if($(this).data("id") == "brand"){
        // $this.parents(".Custom__properties").find(".Custom__properties-label_value").text(value);
        $(this).parents(".Custom__properties-select").find(".Custom__properties-label_value").text(value)
        $this.parents(".Custom__properties").find(".select__select[data-id='model']").attr('name', `properties[${value} Model]`);
        $this.parents(".Custom__properties").find(".select__select[data-id='model']").attr('name-properties', `${value} Model`);
        Models.forEach(function(model){
          if(value == model.Brand){
            model.Models.split(/[,]+/).map(function(item){
              return html += `
                <option value="${item}">${item}</option>
              `
            })   
            $this.parents(".Custom__properties").find(".select__select[data-id='model']").html(html)
          }
        })
        
      }
    });

    $(".template-product ").on("change", " .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      var ID = $this.parents(".Custom__properties-select").data("id");
      if(ID == "car-make"){
        $this.parents(".Custom__properties-select").siblings().fadeIn();
      }
    });


    $(".template-product ").on("click", " .product-single__add-to-cart .btn--add-to-cart", function(e){
      var $this = $(this);
      var tempOject = {};
      var checkValue = false
      var title = $this.parents(".product-single__meta").find(".product-single__title").text().trim();
      var number_of_seats = $this.parents(".product-single__meta").find('[name="options[Number of seats]"]').val();
      var color = $this.parents(".product-single__meta").find('[name="options[Color]"]').val();
      if($(".addOnProperties").length > 0){
        var name = $this.parents(".form").find("#steering-wheel").data("properties");
        var value = $this.parents(".form").find("#steering-wheel").val();
        tempOject[name] = value
      }
      $this.parents(".product-single__form").find(".box--Custom__properties .select__select").each(function( index ) {
        var name = $(this).attr("name-properties");
        var value = $(this).val();
        if(value != null){
          checkValue = true
        }
        tempOject[name] = value
      });

      if(checkValue){
        var tempnoteOrder = localStorage.getItem("noteOrder");
        if(tempnoteOrder == null){
          localStorage.setItem("noteOrder", "");
        }
        var noteOrder = localStorage.getItem("noteOrder");
        var convertempOject = JSON.stringify(tempOject);
        if(typeof number_of_seats == "undefined"){
          var noteProduct = `${title} -- ${color}:${convertempOject}`;
        } else {
          var noteProduct = `${title} -- ${color} / ${number_of_seats}:${convertempOject}`;
        }
        
        
        if(noteOrder == ""){
          newNoteOrder = `${noteProduct}`;
        } else {
          newNoteOrder = `${noteOrder};${noteProduct}`;
        }       
        localStorage.setItem("noteOrder", newNoteOrder);   
        setTimeout(() => {
         $("#Cart-note").val(newNoteOrder)
        }, 3500);
      }
    });
  }

  $("body").on("click", " cart-remove-button .button", function(e){  
    e.preventDefault();
    var tempOject = {};
    var array = localStorage.getItem("noteOrder");
    var newArr = array.split(';');
    var title = $(this).parents(".cart-item").find(".cart-item__name").data("title");
    $(this).parents(".cart-item").find(".list--product-option .product-option--property").each(function( index ) {
      var name = $(this).find("dt").text().trim()
      var value = $(this).find("dd").text().trim()
      tempOject[name] = value
    });
    var convertempOject = JSON.stringify(tempOject);
    var valuesToRemove = `${title}:${convertempOject}`;     
    console.log(valuesToRemove)
    newArr.forEach((item)=>{
      const checkValue = item.includes(valuesToRemove);
      if (checkValue) { // only splice array when item is found
        const index = newArr.indexOf(item);
        newArr.splice(index, 1); // 2nd parameter means remove one item only
      }
    })
    if(newArr.length == 0){
      var convertempArr = "";
    } else {
      var convertempArr = newArr.join(";");
    }    
    localStorage.setItem("noteOrder", convertempArr);
    setTimeout(() => {
      $("#Cart-note").val(convertempArr)
    }, 1500);
    
  });
  if($(".template-cart").length > 0){
    var noteCart = localStorage.getItem("noteOrder");
    $("#Cart-note").val(noteCart)
    $("body").on("click", ".cart__checkout-button", function(e){
      localStorage.removeItem("noteOrder");      
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js', // Adjust the URL as needed for your locale
        success: function(data) {
          // Handle success response
          console.log("Cart cleared successfully");
        },
        error: function(xhr, status, error) {
          // Handle error response
          console.error("Error clearing cart:", error);
        }
      });
    });
     $(".template-cart").on("change", ".card-footer--checkbox #card-footer--input", function(e){
      var ID = $(this).data("id");
      if($(this).is(":checked")){
        $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
              quantity: 1,
              id: ID
           },
           dataType: 'json',
           success: function (data) {
              let cart = jQuery.getJSON('/cart.js');            
              cart.done(function(){
                cart = cart.responseJSON;
                let items = cart.items;
                addCompareAtPrice(cart);               
              })
              function addCompareAtPrice(cart) {
                  cart.items.forEach(function(item) {
                      $.ajax({
                          url: '/products/' + item.handle + '.js',
                          dataType: 'json',
                          async: false,
                          success: function(product) {
                              item["compare_at_price"] = 0;
                              product.variants.forEach(function(variant) {
                                  if (variant.compare_at_price != null && variant.id == item.variant_id) {
                                      item["compare_at_price"] = variant.compare_at_price;
                                  }
                              });
                          }
                      });
                      console.log(item["compare_at_price"])
                  });
                  
                  return cart;
              }
           }
        });        
      } else {
        $.ajax({
           type: 'POST',
           url: '/cart/change.js',
           data: {
              quantity: 0,
              id: ID
           },
           dataType: 'json',
           success: function (data) {

           }
        });
      }
    });
  }

  if($(".dbtfy-upsell_bundles").length > 0){
    function totalPrice(){
      var price = 0;
      var price_compare = 0;
      $(".form-wrapper-upsell_bundles .form-upsell_bundles.active-upsell_bundles").each(function(){
        var $this = $(this);
        price += parseFloat($this.parent().find(".checkbox-upsell_bundles").data("price"))
        price_compare += parseFloat($this.parent().find(".checkbox-upsell_bundles").data("compare-price"))
      })
      $(".dbtfy-ub-price-box .total-upsell_bundles").data("total" , price)
      $(".dbtfy-ub-price-box .total-upsell_bundles").text(Shopify.formatMoney(price))
      $(".dbtfy-ub-price-box .compare-total-upsell_bundles").data("total" , price_compare)
      $(".dbtfy-ub-price-box .compare-total-upsell_bundles").text(Shopify.formatMoney(price_compare))
      $(".dbtfy-ub-price-box .discount-upsell_bundles .discount-upsell_bundles_price").text(Shopify.formatMoney(price_compare-price))
    }

    var items = [];
    function getParent(element, selector) {
        while (element.parentElement) {
            if (element.parentElement.matches(selector)) {
                return element.parentElement;
            }
            element = element.parentElement;
        }
    }
    $(".dbtfy-upsell_bundles").on("click",".box-wrap-upsell_bundles .checkbox-upsell_bundles" ,  function(){
      $(this).parents(".form-item-upsell_bundles").find(".form-upsell_bundles").toggleClass("active-upsell_bundles");
      setTimeout(() => {
        totalPrice();
      }, 1000);
    })
    $(".dbtfy-upsell_bundles").on("click",".btn-upsell_bundles" ,  function(){
      var $this = $(this)
      var forms = document.querySelectorAll(".form-upsell_bundles.active-upsell_bundles");
      const buttonWidth = $this.innerWidth();
      const buttonHeight = $this.innerHeight();
      var data = []
      var isValid = false; 
      forms.forEach(function(form){
        var id = form.querySelector(".select-upsell_bundles").value;
        var selects = form.querySelectorAll(".select__select");
        var properties = {};
        selects.forEach(function(select){
          if(select.value == ""){
            getParent(select,".Custom__properties-select").querySelector(".error").classList.add("is-error")
            select.classList.add("invalid");
          } else {
            getParent(select,".Custom__properties-select").querySelector(".error").classList.remove("is-error")
            select.classList.remove("invalid");
            var name = select.getAttribute("name-properties");
            properties[name] = select.value;
          }
        })
        if($(".Custom__properties-select .select__select.invalid").length == 0){
          isValid = true;
        }
        if(isValid == true){
          $this.css({"width" : buttonWidth , "height" : buttonHeight})
          $this.addClass("btn--loading");
          
          items.push(
            {
              id: id,
              quantity: 1,
              properties: properties
            }
          )
          data = {
            items: items
          }
        }
  
      })
      if(isValid == true){
        $(".form-upsell_bundles.active-upsell_bundles").each(function(){
            var $this = $(this);
            var tempOject = {};
            var checkValue = false
            var title = $this.parent().find(".title-upsell_bundles").text().trim();
            var variant = $this.find(".select-upsell_bundles option:selected").text().trim();
            $this.find(".Custom__properties_upsell .select__select").each(function( index ) {
              var name = $(this).attr("name-properties");
              var value = $(this).val();
              if(value != null){
                checkValue = true
              }
              tempOject[name] = value
            });
            var tempnoteOrder = localStorage.getItem("noteOrder");
            if(tempnoteOrder == null){
              localStorage.setItem("noteOrder", "");
            }
            var noteOrder = localStorage.getItem("noteOrder");
            var convertempOject = JSON.stringify(tempOject);
            var noteProduct = `${title} -- ${variant}:${convertempOject}`;         
            
            if(noteOrder == ""){
              newNoteOrder = `${noteProduct}`;
            } else {
              newNoteOrder = `${noteOrder};${noteProduct}`;
            }       
            localStorage.setItem("noteOrder", newNoteOrder);   
            setTimeout(() => {
             $("#Cart-note").val(newNoteOrder)
            }, 3500);
        })
        fetch('/cart/add.js', {
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        }).then((response) => {
          return response.json();
        }).then((json) => {
          $this.removeClass("btn--loading");
          $this.removeAttr("style")
          var tempnoteOrder = localStorage.getItem("noteOrder");
          var newNoteOrder = `Upsell -- ${tempnoteOrder}`;
          localStorage.setItem("noteOrder", newNoteOrder);   
          window.location.href = '/cart'; 
        }).catch((err) => {
  
        });
      }
    })
    
  }
});
